<template>
  <div class="datepicker">
    <label :for="labelFor"> {{ label }}</label>
    <p class="error m-0">{{ error }}</p>
    <div class="custom-datepicker flex align-center">
      <Datepicker
        :class="[styles, 'flex-1']"
        :id="labelFor"
        :value="value"
        :placeholder="placeholder"
        @input="input"
        @change="$emit('input', $event.target.value)"
      ></Datepicker>
      <div class="calender-icon">
        <label :for="labelFor" class="cursor">
          <span class="mdi mdi-24px mdi-calendar-blank-outline"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker
  },
  props: {
    value: {
      type: String || Date
    },
    label: {
      type: String
    },
    input: {
      type: Function,
      default: () => {}
    },
    labelFor: {
      type: String
    },
    error: {
      type: String
    },
    styles: {
      type: String
    },
    placeholder: {
      type: String
    }
  }
};
</script>

<style>
.datepicker .custom-datepicker {
  margin-top: 10px;
  height: 36px;
  padding: 0;
  border: 1px solid var(--line);
  box-sizing: border-box;
  border-radius: var(--radius-md);
  background: var(--surface);
  overflow: visible;
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
.datepicker .custom-datepicker:focus-within {
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}
.datepicker .vdp-datepicker {
  min-width: 0;
  position: relative;
}
.datepicker .vdp-datepicker input {
  width: 100%;
  height: 34px;
  padding: 0 12px;
  outline: none;
  border: none;
  font-family: var(--font-sans);
  font-size: var(--fs-body);
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--text);
  background: transparent;
}
.datepicker .vdp-datepicker input::placeholder {
  color: var(--muted-soft);
}
.datepicker label {
  font-style: normal;
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 1.4;
  letter-spacing: 0;
  color: var(--muted);
}
.datepicker .calender-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  height: 34px;
  padding: 0;
  border-left: 1px solid var(--line);
}
.datepicker .calender-icon span {
  color: var(--muted-soft);
  font-size: 20px !important;
}
.vdp-datepicker__calendar {
  width: 300px !important;
  z-index: 30;
  padding: 10px 12px 12px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  font-family: var(--font-sans);
}
.vdp-datepicker__calendar header {
  margin: 4px 0 8px !important;
  line-height: 32px !important;
}
.vdp-datepicker__calendar header span {
  font-family: var(--font-sans) !important;
  font-style: normal !important;
  font-weight: 700 !important;
  font-size: var(--fs-h2) !important;
  line-height: 32px !important;
  letter-spacing: 0 !important;
  color: var(--ink-900) !important;
}
.vdp-datepicker__calendar header .prev,
.vdp-datepicker__calendar header .next {
  color: var(--muted) !important;
  font-size: var(--fs-body) !important;
}
.vdp-datepicker__calendar .cell {
  font-style: normal;
  font-weight: 600;
  font-size: var(--fs-body);
  height: 34px !important;
  line-height: 34px !important;
  letter-spacing: 0;
  color: var(--text);
  border-radius: var(--radius-sm);
  border: 1px solid transparent;
}
.vdp-datepicker__calendar .cell.selected {
  background: var(--accent-050) !important;
  color: var(--accent-600) !important;
  border-radius: var(--radius-sm) !important;
  font-weight: 700;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled):hover {
  background: var(--accent-050) !important;
  border: 1px solid var(--accent-500) !important;
  border-radius: var(--radius-sm) !important;
}
.vdp-datepicker__calendar .cell.today:not(.selected) {
  background: transparent !important;
  color: var(--accent-600) !important;
  border-color: var(--accent-500);
}
.vdp-datepicker__calendar .day-header {
  height: 28px !important;
  color: var(--muted);
  font-family: var(--font-sans) !important;
  font-style: normal;
  font-weight: 700;
  font-size: var(--fs-xs) !important;
  line-height: 28px !important;
  letter-spacing: 0.04em !important;
  text-transform: uppercase;
}
</style>
